/**
 * Facility user types, and what a BRANCH may have.
 *
 * A branch has no Facility Admin account. Only Front Desk Officer and Claims
 * Officer are defined for branch users in RBAC; "Operational Admin" (3) has no
 * RBAC definition and used to create a Claims Officer, so branches never offer
 * it (the API refuses it with 422 as well).
 */
export const FACILITY_USER_ROLE_OPTIONS = [
  { value: 1, label: 'Front Desk Officer' },
  { value: 2, label: 'Claims Officer' },
  { value: 3, label: 'Operational Admin' },
];

export const BRANCH_USER_ROLE_OPTIONS = FACILITY_USER_ROLE_OPTIONS.filter((o) => o.value === 1 || o.value === 2);

export const roleOptionsFor = (isBranch) => (isBranch ? BRANCH_USER_ROLE_OPTIONS : FACILITY_USER_ROLE_OPTIONS);

/**
 * What happened to the branch's "user created" email (data.branch_notification).
 * @returns {{type: 'success'|'warning'|'info', text: string}|null}
 */
export const branchNoticeMessage = (notice) => {
  if (!notice || !notice.status) return null;
  if (notice.status === 'sent') {
    return { type: 'success', text: `The login ID and password were emailed to the branch at ${notice.email}.` };
  }
  if (notice.status === 'skipped_no_email') {
    return { type: 'info', text: "The branch has no email on its Facility Information, so nothing was emailed. Give the user these details yourself." };
  }
  return {
    type: 'warning',
    text: `The email to the branch${notice.email ? ` at ${notice.email}` : ''} could not be sent. Give the user these details yourself.`,
  };
};
